"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var query = require("../query");
var request_animation_frame_1 = require("./request-animation-frame");
function scrollTo(selected, scrollParent) {
    var offset = query.offset(selected);
    var poff = {
        top: 0,
        left: 0
    };
    var listScrollTop;
    var isWin;
    if (!selected) {
        return;
    }
    var list = scrollParent || query.scrollParent(selected);
    isWin = query.getWindow(list);
    listScrollTop = query.getScrollTop(list);
    var listHeight = query.height(list, true);
    isWin = query.getWindow(list);
    if (!isWin) {
        poff = query.offset(list);
    }
    offset = {
        top: offset.top - poff.top,
        left: offset.left - poff.left,
        height: offset.height,
        width: offset.width
    };
    var selectedHeight = offset.height;
    var selectedTop = offset.top + (isWin ? 0 : listScrollTop);
    var bottom = selectedTop + selectedHeight;
    listScrollTop = listScrollTop > selectedTop
        ? selectedTop
        : bottom > (listScrollTop + listHeight)
            ? (bottom - listHeight)
            : listScrollTop;
    var id = request_animation_frame_1.requestAnimationFrame(function () { return query.setScrollTop(list, listScrollTop); });
    return function () { return request_animation_frame_1.requestAnimationFrame.cancel(id); };
}
exports.scrollTo = scrollTo;
